import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="m248-106-56-55 211-212q23-22 30-40 7-19 7-56v-234l-90 90-55-56 185-185 185 185-55 56-90-90v234q0 37 7 56 7 18 30 40l211 212-56 55-232-232-232 232Z"/>',
  f: '<path d="m248-106-56-55 211-212q23-22 30-40 7-19 7-56v-234l-90 90-55-56 185-185 185 185-55 56-90-90v234q0 37 7 56 7 18 30 40l211 212-56 55-232-232-232 232Z"/>',
};

export default data;
